export default [
  {
    name: "2018 UPPAbaby CRUZ Stroller- Gregory (Silver Leather)",
    price: "549.99 ",
    url:
      "https://www.amazon.com/dp/B01MT11067/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01MT11067&linkCode=as2&tag=shopmymom-20&linkId=dca6bea807c87f5af5c63cde8e88998b",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81n%2BxJZ7u%2BL._SX522_.jpg",
    description:
      "We looked at a bunch of different strollers, and this was a bit cheaper than our other choice, and is a great build, made from excellent materials, and handles well with fairly large wheels.",
    category: ["Gear"]
  },
  {
    name:
      "babyletto Gelato 4-in-1 Convertible Crib with Toddler Bed Conversion Kit, Washed Natural",
    price: "299.00 ",
    url:
      "https://www.amazon.com/gp/product/B01614LN22/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01614LN22&linkCode=as2&tag=shopmymom-20&linkId=46b808d6d519eb2d8d407045ef2b4946",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81IJZCfVt2L._SX522_.jpg",
    description:
      "Made with sustainable New Zealand pine wood, it has a beautiful neutral wood color, and was easy to put together. It comes with a toddler bed conversion kit, so it’ll grow with our daughter.",
    category: ["Furniture"]
  },
  {
    name: "Chicco KeyFit 30 Magic Infant Car Seat, Coal",
    price: "209.99 ",
    url:
      "https://www.amazon.com/gp/product/B00WOPRB2Y/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00WOPRB2Y&linkCode=as2&tag=shopmymom-20&linkId=07b2c2ba7954bf119428744b6de80bde",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/91y-R%2BRW9hL._SX522_.jpg",
    description:
      "This is a really popular car seat. It’s safe, and will last your child until they reach 2.5ft tall or 30lbs. Our daughter is in the 99% percentile for height so we probably only have a few months left.",
    category: ["Car Seats"]
  },
  {
    name: "BABYBJORN Bouncer Balance Soft - Black/Dark Gray, Cotton",
    price: "199.99 ",
    url:
      "https://www.amazon.com/gp/product/B00BQYVOKY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00BQYVOKY&linkCode=as2&tag=shopmymom-20&linkId=50687976ef8efd6a98c7e44c985b346a",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81G43FVEyeL._SX522_.jpg",
    description:
      "This Swedish ergonomic bouncer is clean and minimal. When we need a 5 or 10 minute breather, a seat like this in invaluable. Buy the attachable wooden Googly Eyes for her to play with.",
    category: ["Gear"]
  },
  {
    name: "Hatch Baby Rest Night Light, Sound Machine and Time-to-Rise",
    price: "59.99",
    url:
      "https://www.amazon.com/gp/product/B06XMRCC94/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XMRCC94&linkCode=as2&tag=shopmymom-20&linkId=e0e7e527b5baade92f497b709ceead8b",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61ASu-5HgBL._SX522_.jpg",
    description:
      "White noise helps her sleep plus you can control it through your phone! There are other convenient ways of controlling it like pressing the top of it to stop or play the most recent. The colors give the room an ambient glow too.",
    category: ["Gear"]
  },
  {
    name:
      "Slumberkins - BigFoot - Cuddly Creatures with Intention (Snuggler Bundle, Ultra Plush - Brown)",
    price: "48",
    url:
      "https://www.amazon.com/gp/product/B078XNSFZ5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B078XNSFZ5&linkCode=as2&tag=shopmymom-20&linkId=13619c10d1ffbb371fccd19a17ee5eca",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71vRFLviibL._SX679_.jpg",
    description:
      "These were featured on sharktank, and our baby loves hers. Apparently, they’re sold out all the time. Could only find this bigfoot one on amazon. They’re very soft and cuddly, and we keep hers in her crib and helps her sleep for sure.",
    category: ["Gear"]
  },
  {
    name: "BABYBJORN Wooden Toy for Bouncer - Googly Eyes",
    price: "38.76",
    url:
      "https://www.amazon.com/gp/product/B001HX4DNE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001HX4DNE&linkCode=as2&tag=shopmymom-20&linkId=5d02faf092e6c2b4c0683535bf811683",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/615bf73PcHL._SX522_.jpg",
    description: "Attaches to the BabyBjorn bouncer.",
    category: ["Gear"]
  },
  {
    name:
      "Moonlight Slumber Little Dreamer Dual Sleep Surface Crib Mattress - Waterproof, Hypoallergenic, and Antimicrobial Lightweight Crib Mattress with Extra Firm Infant Side and Plush Toddler Side",
    price: "196.90 ",
    url:
      "https://www.amazon.com/gp/product/B00P9RB0OE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00P9RB0OE&linkCode=as2&tag=shopmymom-20&linkId=5b9c998275bb98ecb80a0a9732942f34",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71g%2Br6qZN3L._SY679_.jpg",
    description:
      "We looked at a few mattresses, and chose this one for the dual side sleep system that she can also grow with and it’s high performance ratings.",
    category: ["Furniture"]
  },
  {
    name:
      "Infant Optics DXR-8 Video Baby Monitor with Interchangeable Optical Lens",
    price: "165.99 ",
    url:
      "https://www.amazon.com/gp/product/B00ECHYTBI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00ECHYTBI&linkCode=as2&tag=shopmymom-20&linkId=3e65992bfccc8c29bc1c3d715ad6de6d",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81g5ls7JhTL._SX522_.jpg",
    description:
      "There are alot of options for baby monitors, but ultimately decided on this one because the speakers will go on if there are any sounds emmitted, 360 degree remote access, and night vision. We also chose non-wifi because of the off chance of any hacking into the feed. It's light weight, and screwed into the wall above her crib.",
    category: ["Safety"]
  },
  {
    name:
      "Baby Tula Free-to-Grow Baby Carrier, Adjustable Newborn to Toddler Carrier, Ergonomic and Multiple Positions for 7 – 45 pounds",
    price: "159",
    url:
      "https://www.amazon.com/gp/product/B01J4K3TEK/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J4K3TEK&linkCode=as2&tag=shopmymom-20&linkId=0ee8b0589f8a49a5c666dcb9e2d817b8",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/712v1D02ZeL._SY679_.jpg",
    description:
      "We first bought the Gemini Performance Baby Carrier by Beco, but my wife discovered this one from a Mommy and Me Meetup. We returned the Beco and this is our go to carrier! We actually got the 'Wonder' design, but is out of stock at the moment.",
    category: ["Gear"]
  },
  {
    name:
      "Skip Hop Explore and More Baby's View 3-Stage Activity Center, Multi, 4 Months",
    price: "110.19 ",
    url:
      "https://www.amazon.com/gp/product/B01J94K9OY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01J94K9OY&linkCode=as2&tag=shopmymom-20&linkId=dea60cf8ed5c23737d712eb4aba48324",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81uginCh%2BQL._SX522_.jpg",
    description:
      "This was in our registry, and we actually just put it together the other day. She can spin around, and every turn there’s something colorful and new to play with!",
    category: ["Toys"]
  },
  {
    name: "Canon Selphy CP1200 White Wireless Color Photo Printer",
    price: "99.48 ",
    url:
      "https://www.amazon.com/gp/product/B073YHRPV5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B073YHRPV5&linkCode=as2&tag=shopmymom-20&linkId=68fc668c57f5ac0903c78450a917642a",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/313DGG7omnL.jpg",
    description:
      "For printing those photos into those picture frames I’m sure you’ll have. Also great for use in scrap/memory books. We used them in The Belly Book and My Baby Book.",
    category: ["Gear"]
  },
  {
    name: "JOOVY Nook High Chair, Coral",
    price: "94.99 ",
    url:
      "https://www.amazon.com/gp/product/B01KQ16MP4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01KQ16MP4&linkCode=as2&tag=shopmymom-20&linkId=366e9f016b5b3cb32137ea2c29dda5e7",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61JHzDGRIgL._SX522_.jpg",
    description:
      "It was down to this one or the Scandinavian Stokke Tripp Trapp high chair. Though the Tripp Trapp would have fit with our wooden bench. It came down to costs where it was the half the price. It’s design is so sleek and the Deluxe, Padded Leatherette Seat looks like something you’d find in an Italian sportcar. ",
    category: ["Feeding"]
  },
  {
    name:
      'Skip Hop Playspot Waterproof Foam Baby Play Mat, Grey/Peach, 70" X 56"',
    price: "78.99 ",
    url:
      "https://www.amazon.com/gp/product/B00SHYJ0G6/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00SHYJ0G6&linkCode=as2&tag=shopmymom-20&linkId=abdee60de659f05c1063881ace324120",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71LLdiwoRnL._SX522_.jpg",
    description:
      "We haven’t used this yet, but will be pulled out later when we have a play area on the floor for her.",
    category: ["Toys"]
  },
  {
    name: "Skip Hop Silver Lining Cloud Activity Gym, Multi",
    price: "62.90 ",
    url:
      "https://www.amazon.com/gp/product/B01G1JQXMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01G1JQXMW&linkCode=as2&tag=shopmymom-20&linkId=da4b9e3901be2c4f3bfcb2b5b10fa420",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61q6Sw3cf0L._SX522_.jpg",
    description:
      "This was her first playmat where she got plenty of tummy time. We placed a reflective soft mirror in front of her for something to focus on. ",
    category: ["Toys"]
  },
  {
    name: "Graco Pack N’ Play Playard Nimble Nook, Sapphire",
    price: "55.99",
    url:
      "https://www.amazon.com/gp/product/B073HB2ZXW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B073HB2ZXW&linkCode=as2&tag=shopmymom-20&linkId=0e07690fa613ec0aa266f00f9ed59b15",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/91EeQVyDKxL._SL1500_.jpg",
    description:
      "We used this as her bassinet for the first two months right next to our bed. It comes with a device for vibration, which she seemed to like at first, but was not necessary soon after. We now use it as a playpen as it converts to a larger surface area when you place the mat to the bottom of the pen.",
    category: ["Toys", "Furniture"]
  },
  {
    name:
      "aden + anais Silky Soft Dream Blanket, 100% Cotton Bamboo Muslin, 4 Layer Lightweight and Breathable, 47 X 47 inch, Berry Shibori - Pink",
    price: "50.96 ",
    url:
      "https://www.amazon.com/gp/product/B01LWYAU60/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01LWYAU60&linkCode=as2&tag=shopmymom-20&linkId=71e5548007225224c9dd9c2c26f3cfdf",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81Lzjq4aG6L._SX522_.jpg",
    description: "A soft muslin with a colorful pattern.",
    category: ["Bedding"]
  },
  {
    name: "UPPAbaby Infant Car Seat Adapter for Chicco",
    price: "44.99 ",
    url:
      "https://www.amazon.com/gp/product/B00YZFYDKY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00YZFYDKY&linkCode=as2&tag=shopmymom-20&linkId=1f21fa11d78c276c3b8cdccb06ea6547",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61fQozVje2L._SX522_.jpg",
    description:
      "If you have the UPPAbaby stroller, and the Chicco car seat, this adapter let’s you use both together. Made it convenient to remove the entire carseat and connect to a stroller, especially as a newborn.",
    category: ["Car Seats"]
  },
  {
    name: "KidKraft Sling Bookshelf, Natural",
    price: "40.83 ",
    url:
      "https://www.amazon.com/gp/product/B0018MCVH4/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0018MCVH4&linkCode=as2&tag=shopmymom-20&linkId=bd1ee1e1c0e2ee34d7426ca99ddaa2e7",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81Ziq-7XskL._SX679_.jpg",
    description:
      "This is a nice, minimal wood colored first bookshelf. Books are prominently displayed face forward.",
    category: ["Toys"]
  },
  {
    name: "UPPAbaby Infant SnugSeat",
    price: "39.99 ",
    url:
      "https://www.amazon.com/gp/product/B0051Y1L1W/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0051Y1L1W&linkCode=as2&tag=shopmymom-20&linkId=dca5bf201e30336481fc4429f11c016b",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/51KpKyNRlgL._SX522_.jpg",
    description:
      "This extra additional stroller padding gives her a bit more support.",
    category: ["Car Seats"]
  },
  {
    name: "Boba Wrap, Grey, 0-36 Months",
    price: "39.95 ",
    url:
      "https://www.amazon.com/gp/product/B005SP2LWW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B005SP2LWW&linkCode=as2&tag=shopmymom-20&linkId=cb6b18a773e5837ce7852f8ded7c0992",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/91vIWtma2-L._SY679_.jpg",
    description:
      "This is one of many carriers we used. It was confusing at first how to put it on, so watch some videos and practice! For men who like minimalist fashion design, their peers might think they’re wearing Rick Owens.😎",
    category: ["Gear"]
  },
  {
    name:
      "aden + anais Silky Soft Swaddle Baby Blanket, Viscose Bamboo Muslin, Large 47 X 47 inch, 3 Pack, Indigo, Blue",
    price: "39.49 ",
    url:
      "https://www.amazon.com/gp/product/B01CDEP4HO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01CDEP4HO&linkCode=as2&tag=shopmymom-20&linkId=e92e417ddffc7d6cefe861d57b552a93",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/8179DrWpkfL._SX522_.jpg",
    description: "Part of our swaddling arsenal. We love these, super soft.",
    category: ["Bedding"]
  },
  {
    name:
      "Lamaze - Octotunes Musical Toy, Help Baby Discover and Play with Sound, with Bright Colors, Fun Textures, and Eight Notes, 0 Months and Older",
    price: "34.99 ",
    url:
      "https://www.amazon.com/gp/product/B000I2MRMY/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000I2MRMY&linkCode=as2&tag=shopmymom-20&linkId=7db9a2f5d0766a2c925d270649de8a2c",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/51kPJ-O0lcL.jpg",
    description:
      "This is unique since you can squeeze each paw for a different musical note. It’s not played with that much, but maybe when she’s a bit older.",
    category: ["Toys"]
  },
  {
    name:
      "Organic Crib Mattress Cover Pad – Waterproof and Breathable Bamboo Baby Mattress Pad - Fits ALL Standard Crib Sizes",
    price: "29.97 ",
    url:
      "https://www.amazon.com/gp/product/B00VU8BF14/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00VU8BF14&linkCode=as2&tag=shopmymom-20&linkId=4caaeb8860aa8bc9b34eea18d0012d6d",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/9101BT8fy4L._SX522_.jpg",
    description:
      "You’ll want that extra protection for any blow outs or milk vomit. yum.😌",
    category: ["Bedding"]
  },
  {
    name:
      "Lansinoh Nursing Pads, 4 Packs of 60 (240 count) Stay Dry Disposable Breast Pads",
    price: "27.96 ",
    url:
      "https://www.amazon.com/gp/product/B002TLU5JO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B002TLU5JO&linkCode=as2&tag=shopmymom-20&linkId=25ee013d6559c9727d849d78dd8fb438",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81IEQO7mfXL._SX522AA522_PIbundle-4,TopRight,0,0_AA522_SH20_.jpg",
    description:
      "They have a quilted, honeycomb lining and a unique breathable waterproof layer for leakproof protection",
    category: ["Feeding"]
  },
  {
    name: "Manhattan Toy Wimmer-Ferguson Infant Stim-Mobile for Cribs",
    price: "26.20 ",
    url:
      "https://www.amazon.com/gp/product/B00W89SX2S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00W89SX2S&linkCode=as2&tag=shopmymom-20&linkId=003a19105f1858c0b78b187fd82141ec",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71-A9mSFuQL._SX679_.jpg",
    description:
      "From the Wimmer-Ferguson collection, has high contrast minimal design. We would wound it up for 5 minutes and then let it spin. I wish that part was motorized though.",
    category: ["Nursery Décor"]
  },
  {
    name:
      "Halo 100% Cotton Muslin SleepSack Wearable Blanket, Grey Tree Leaf, Medium",
    price: "24.99 ",
    url:
      "https://www.amazon.com/gp/product/B017GAA7TU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B017GAA7TU&linkCode=as2&tag=shopmymom-20&linkId=f6d71a9bd230659c56b431fc6541b9cc",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/91JBYUt4gvL._SX522_.jpg",
    description:
      "As soon as she was old enough (maybe 2 months?) where she no longer had to be swaddled, she was completely switched over to sleepsacks til the time of writing this. ",
    category: ["Bedding", "Apparel"]
  },
  {
    name:
      "Burt's Bees Baby - 5 Pack of Burp Cloths, 100% Organic Cotton (1 Cloud, 1 Solid Color, 1 Honey Bee Print, 1 Stripe, 1 Alphabet Bee Print, Heather Grey)",
    price: "24.95 ",
    url:
      "https://www.amazon.com/gp/product/B01HG74QLI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HG74QLI&linkCode=as2&tag=shopmymom-20&linkId=8a624fa76b26163cb65a2f2f0fc51fde",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/9179IuYGLtL._SX522_.jpg",
    description:
      "We have a variety of burp cloths, but these just look really nice and are soft and absorbent.",
    category: ["Feeding"]
  },
  {
    name: "HALO SleepSack 100% Cotton Swaddle, Sage, Newborn",
    price: "22.49 ",
    url:
      "https://www.amazon.com/gp/product/B001PBNJ1U/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001PBNJ1U&linkCode=as2&tag=shopmymom-20&linkId=2863b7250c9e35f52cef23c6c23ced29",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81XB4CVLhnL._SX522_.jpg",
    description:
      "Moving from swaddling with muslin, this is just as effective though you can't swaddle as tightly.",
    category: ["Bedding", "Apparel"]
  },
  {
    name: "HALO SleepSack Micro-Fleece Swaddle, Cream, Small",
    price: "21.99 ",
    url:
      "https://www.amazon.com/gp/product/B001D7JO1U/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B001D7JO1U&linkCode=as2&tag=shopmymom-20&linkId=120eebc8122a21609dcc1704b37ec3c0",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71QLfgo1DuL._SX522_.jpg",
    description: "This is the micro-fleece version so good for colder weather.",
    category: ["Bedding", "Apparel"]
  },
  {
    name: "AmazonBasics Kids Velvet Hangers - 50-Pack, Beige",
    price: "20.99 ",
    url:
      "https://www.amazon.com/gp/product/B07411XQ74/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07411XQ74&linkCode=as2&tag=shopmymom-20&linkId=67d254117348db37d20f7cf4f4a2569d",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81l0FcIaklL._SX522_.jpg",
    description: "This is a nice value buy straight from amazon",
    category: ["Apparel"]
  },
  {
    name: "Fridababy NoseFrida Nasal Aspirator with 20 Extra Hygiene Filters",
    price: "20.00 ",
    url:
      "https://www.amazon.com/gp/product/B00RP0GHBO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00RP0GHBO&linkCode=as2&tag=shopmymom-20&linkId=a78bfe4bc8785b4b05092be9dc9fab97",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/41GiWFhmDwL.jpg",
    description: "We haven’t used it yet, but good to have on hand.",
    category: ["Health"]
  },
  {
    name: "OXO TOT Perfect Pull Wipes Dispenser",
    price: "19.99",
    url:
      "https://www.amazon.com/gp/product/B0771HG9JS/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0771HG9JS&linkCode=as2&tag=shopmymom-20&linkId=1f81ccec8f85feaf7f0bb69268a4c3cb",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81drnEppSxL._SX522_.jpg",
    description: "Solid dispenser for wipes. Keeps moisture in, good build.",
    category: ["Gear", "Diapering"]
  },
  {
    name: "OXO Tot On-The-Go Wipes Dispenser, Gray",
    price: "7.99",
    url:
      "https://www.amazon.com/gp/product/B01MDMYDJO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01MDMYDJO&linkCode=as2&tag=shopmymom-20&linkId=6295c95c366ff3618e93f38197693a50",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61b-VqDprLL._SX522_.jpg",
    description: "Great for when you’re on the go.",
    category: ["Gear", "Diapering"]
  },
  {
    name:
      "Organic Bamboo Baby Hooded Towel with Bonus Washcloth | Ultra Soft and Super Absorbent Toddler Hooded Bath Towel with Cute Lamb Face Design | Great Infant/Newborn Shower Present for Boy or Girl",
    price: "19.99 ",
    url:
      "https://www.amazon.com/gp/product/B06XCT43MX/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XCT43MX&linkCode=as2&tag=shopmymom-20&linkId=4b6157c2952cdfb343abad9b35822fb6",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71VoR6bPT1L._SX522_.jpg",
    description:
      "Your child doesn’t want just any towel, no.. it has to have a cute lamb face.☺️ Also it’s a little bit easier to dry their hair off when they’re wearing it like a little cap.",
    category: ["Bathing & Skin Care"]
  },
  {
    name:
      "10-Pack Bandana Bibs Upsimples Baby Drool Bibs for Drooling and Teething, 100% Cotton Super Absorbent, 10 Stylish Design for Baby Girls Toddler, Baby Shower Gift Set",
    price: "18.99 ",
    url:
      "https://www.amazon.com/gp/product/B07216Q7ZR/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07216Q7ZR&linkCode=as2&tag=shopmymom-20&linkId=8658d92e42d31831ec2bb81831cf7169",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/713DyKOFA5L._SX522_.jpg",
    description:
      "When she’s a bit older, there will be drool and spit up. These little bandana bibs look cute and will be there to catch it.",
    category: ["Feeding"]
  },
  {
    name: "Vicks Baby Rectal Thermometer",
    price: "18.77",
    url:
      "https://www.amazon.com/gp/product/B00LY5KQVS/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00LY5KQVS&linkCode=as2&tag=shopmymom-20&linkId=cc5fe3e525cd75812ce8eb41e041b761",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/41-LWrDru8L.jpg",
    description:
      "We’ve read these are better than under arm thermometers with reading temperatures.",
    category: ["Health"]
  },
  {
    name: "Summer Infant Contoured Changing Pad",
    price: "17.99 ",
    url:
      "https://www.amazon.com/gp/product/B009EDSWJA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B009EDSWJA&linkCode=as2&tag=shopmymom-20&linkId=54aba31d563825b601e78d2be55d1760",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81%2Bev0VHJHL._SX522_.jpg",
    description:
      "We have this placed on top of our Ikea Hemnes dresser. It’s again, soft, and contoured to keep her in centered. This is a must buy.",
    category: ["Diapering"]
  },
  {
    name:
      "Earth Mama Sweet Orange Baby Lotion with Organic Calendula, 8-Fluid Ounce",
    price: "17.99",
    url:
      "https://www.amazon.com/gp/product/B000P7M26I/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000P7M26I&linkCode=as2&tag=shopmymom-20&linkId=1caa0ea8164f9cb8471273d75578c354",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61L2fOvkskL._SY679_.jpg",
    description: "After her daily bath, we massage this baby lotion on her.",
    category: ["Bathing & Skin Care"]
  },
  {
    name:
      "Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Sky)",
    price: "17.99 ",
    url:
      "https://www.amazon.com/gp/product/B00PYCPUFE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00PYCPUFE&linkCode=as2&tag=shopmymom-20&linkId=4df7b551a437761e47d72d9cca1e1ed0",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71LG7SxjeOL._SX522_.jpg",
    description: "Nice design, and comfortable.",
    category: ["Bedding"]
  },
  {
    name:
      "Baby Diaper Caddy Organizer | Bonus Card Holder | Nursery Storage Bin for Diapers, Wipes & Toys | Portable Car Storage Basket | Changing Table Organizer | Great Baby Shower Gift Basket by Pandiee",
    price: "17.95 ",
    url:
      "https://www.amazon.com/gp/product/B074P7CDZP/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B074P7CDZP&linkCode=as2&tag=shopmymom-20&linkId=72fb7140659607abf6217f382d2e5f3a",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/A1gASqU0edL._SX522_.jpg",
    description:
      "We’ve got two! One for diapers in the nursery, and the other in the living room for toys and burp cloths.",
    category: ["Toys", "Diapering"]
  },
  {
    name:
      "Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Heather Grey)",
    price: "17.95 ",
    url:
      "https://www.amazon.com/gp/product/B011CK9FIE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B011CK9FIE&linkCode=as2&tag=shopmymom-20&linkId=3b6d15b67cabb9b46e77edc2bb46a940",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81BCjKH5YaL._SX522_.jpg",
    description: "Heather Grey edition, tally-ho 🙌",
    category: ["Bedding"]
  },
  {
    name: "Carter's Baby 2-Pack Sleeper Gowns with Elephant Print Newborn",
    price: "15.98",
    url:
      "https://www.amazon.com/gp/product/B072JK58QR/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B072JK58QR&linkCode=as2&tag=shopmymom-20&linkId=3983fa521875d7ac41dcf49ef32cd550",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/81Grq5DV5-L._UY879_.jpg",
    description:
      "These were wonderful when she was a newborn. Can sleep all comfy in this.",
    category: ["Apparel"]
  },
  {
    name: "Sophie La Girafe - So Pure Teether Giraffe",
    price: "15.19 ",
    url:
      "https://www.amazon.com/gp/product/B0038JDAJ8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0038JDAJ8&linkCode=as2&tag=shopmymom-20&linkId=fd9b14aae0c23bfd1b0cbd6f60d50bb5",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71YnQNyhhIL._SX522_.jpg",
    description:
      "She’s not quite teething yet, but she’ll still chew on this regardless.",
    category: ["Toys"]
  },
  {
    name: "Manhattan Toy Whoozit Space Blankie Sensory Development Toy",
    price: "15.07 ",
    url:
      "https://www.amazon.com/gp/product/B00VANVD0M/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00VANVD0M&linkCode=as2&tag=shopmymom-20&linkId=5c0bb56e2ac02474fc17aba6b632426c",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71vsyUg0uuL._SX679_.jpg",
    description:
      "She played with this early on as newborn. It’s colorful, and we usually had her play with it in the play gym.",
    category: ["Toys"]
  },
  {
    name: "Wubbanub Infant Pacifier - Birthday Bichon",
    price: "14.95 ",
    url:
      "https://www.amazon.com/gp/product/B0713TP16Q/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0713TP16Q&linkCode=as2&tag=shopmymom-20&linkId=661b3ec85956f38d5cb4719928edaeef",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71NExCpFh8L._SX522_.jpg",
    description:
      "She was sucking on the pacifier early, early on, but she’s switched to her thumb!",
    category: ["Feeding"]
  },
  {
    name:
      "Manhattan Toy Classic Baby Beads Wood Rattle, Teether, and Clutching Toy",
    price: "14.69 ",
    url:
      "https://www.amazon.com/gp/product/B002LARAOG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B002LARAOG&linkCode=as2&tag=shopmymom-20&linkId=2dc8fd7fb06b1b0ca80b6c8a64f95a24",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/615cCas6uIL._SX522_.jpg",
    description:
      "I just pulled this out, and she immedietly put it to her mouth 😂",
    category: ["Toys"]
  },
  {
    name: "Sonilove Baby Car Mirror",
    price: "13.98 ",
    url:
      "https://www.amazon.com/gp/product/B01K478YBA/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01K478YBA&linkCode=as2&tag=shopmymom-20&linkId=cdfdfcc246d520e9a5b11815f011866c",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/517-KRGXIFL.jpg",
    description: "This is a novel way of checking on your baby while driving.",
    category: ["Car Seats"]
  },
  {
    name: "Comotomo Natural Feel Baby Bottle, Green, 8 Ounces",
    price: "13.25 ",
    url:
      "https://www.amazon.com/gp/product/B004C053AQ/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004C053AQ&linkCode=as2&tag=shopmymom-20&linkId=cc50789db1d4532aaa653f40eb3d4551",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61oAstrEdwL._SX522_.jpg",
    description:
      "We started with these bottles, and we approve! They’re soft to hold, and has a natural feel.",
    category: ["Feeding"]
  },
  {
    name:
      "Stretchy Changing Pad Covers-BROLEX 2 Pack Jersey Knit Change Pad Covers For Girls Boys,Pink & White Arrow",
    price: "12.99 ",
    url:
      "https://www.amazon.com/gp/product/B071L4GTMW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B071L4GTMW&linkCode=as2&tag=shopmymom-20&linkId=a93036de85345b53aaee1cce1517e621",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61Xr0wv-agL._SX522_.jpg",
    description: "These go over for the changing pad, and is a fun pattern.",
    category: ["Diapering", "Bedding"]
  },
  {
    name:
      "Burt's Bees Baby - Fitted Crib Sheet, Thin Stripes, 100% Organic Cotton Crib Sheet For Standard Crib and Toddler Mattresses (Blossom)",
    price: "12.99 ",
    url:
      "https://www.amazon.com/gp/product/B00LY36WNG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00LY36WNG&linkCode=as2&tag=shopmymom-20&linkId=a58c0c7b6083ab6f993f1dea95291a5e",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71jNrLa5A2L._SX522_.jpg",
    description:
      "You’ll need plenty of these crib sheets, so buy a variety of patterns.",
    category: ["Bedding"]
  },
  {
    name:
      "Car seat Canopy Nursing Cover - Multi use Baby Stroller and carseat Cover, Breastfeeding Nursing Covers, Boys and Girls Shower Gifts (Classical Arrows)",
    price: "12.95 ",
    url:
      "https://www.amazon.com/gp/product/B06XCGH232/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B06XCGH232&linkCode=as2&tag=shopmymom-20&linkId=6e37b12de8a5b89593eb392eafb7ffb1",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/818lBt1Q6eL._SX522_.jpg",
    description:
      "This is a really useful cover for the stroller, or when nursing out in public.",
    category: ["Feeding", "Car Seats"]
  },
  {
    name: "Comotomo Natural Feel Baby Bottle, Pink, 8 Ounces",
    price: "11.98 ",
    url:
      "https://www.amazon.com/gp/product/B004C053AG/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004C053AG&linkCode=as2&tag=shopmymom-20&linkId=b89b59af6b1036579e7676ea7028291b",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/612gtwx536L._SX522_.jpg",
    description: "The pink version.",
    category: ["Feeding"]
  },
  {
    name:
      "Manhattan Toy Skwish Classic Rattle and Teether Grasping Activity Toy",
    price: "11.98 ",
    url:
      "https://www.amazon.com/gp/product/B000GI0S4E/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000GI0S4E&linkCode=as2&tag=shopmymom-20&linkId=4af2f626a854f48a848d597d4d36b36e",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71Qfh8Bj91L._SX522_.jpg",
    description:
      "This is another toy she plays with quite regularly. She’ll either put it in her mouth, or hold it. If you turn it, the beads fall towards that side and has a somewhat hypnotic effect.",
    category: ["Toys"]
  },
  {
    name:
      "White Newborn Baby Mittens by Nurses Choice (Includes 6 Pairs of No Scratch Cotton Mittens)",
    price: "10.99 ",
    url:
      "https://www.amazon.com/gp/product/B01KKETQPU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01KKETQPU&linkCode=as2&tag=shopmymom-20&linkId=9d5795698826fb421ecdbb035c73ce85",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61xGVeAKRiL._SX522_.jpg",
    description:
      "Our baby does scratch herself in her sleep, so these can be helpful, though these newborn ones only last for a month or so.",
    category: ["Apparel"]
  },

  {
    name:
      "Black, White & Red Infant-Stim Clip Along High Contrast Flash Cards for Baby",
    price: "10.95 ",
    url:
      "https://www.amazon.com/gp/product/B01HMXOI6E/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HMXOI6E&linkCode=as2&tag=shopmymom-20&linkId=038d5c740d8e9649a288c7c08f152b63",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/61c-wB4bUuL._SX522_.jpg",
    description:
      "When she first arrived in our home, we showed her these cards to look at and would say the name of the animal or person to her. It can be a talking point, and just something to focus on.",
    category: ["Toys"]
  },
  {
    name:
      "Kassa Inc Static Cling UV Protection Car Sun Shades, Black, Set of 2",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B00P0A6OM8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00P0A6OM8&linkCode=as2&tag=shopmymom-20&linkId=2d41367438e5c1dfee3e4f33f96ae1f0",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/51LAvFhc0vL.jpg",
    description:
      "It’s recommended that you don’t use any sunscreen on your child, so this can be good for the backseat area to keep a little more sunlight out.",
    category: ["Car Seats"]
  },
  {
    name: "Sassy Developmental Bumpy Ball",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B004AHMCMI/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B004AHMCMI&linkCode=as2&tag=shopmymom-20&linkId=e353adcafa55aaa9b6f935614d4fb3e0",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/91O2QHfRwsL._SX522_.jpg",
    description:
      "We’ve just introduced this toy as well, and she puts this to her mouth as well and likes rolling it around. ",
    category: ["Toys"]
  },
  {
    name: "Skip Hop Moby Bath Tear-Free Waterfall Rinser Bath Cup, Blue",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B00FXR5S20/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00FXR5S20&linkCode=as2&tag=shopmymom-20&linkId=34da791df9d51c70fd0f5b3a75f11f61",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/817z3ag2L%2BL._SX522_.jpg",
    description:
      "We have a whale theme going on in the bathroom so we use this for every bath. We’ll fill this up and gently pour on her head for washing her hair as well as just washing soap off. ",
    category: ["Bathing & Skin Care"]
  },
  {
    name: "Skip Hop Silver Lining Cloud Jitter Stroller Toy, Multi",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B01HG1LA6S/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01HG1LA6S&linkCode=as2&tag=shopmymom-20&linkId=f5130bdbda2bcaa587c98583a2b427dc",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/510DMq4jhqL._SX522_.jpg",
    description:
      "We have stuck this in different areas. Right now it’s on her activity center, or earlier, it was looped to the top canopy of the playmat. ",
    category: ["Toys"]
  },
  {
    name: "Manhattan Toy Winkel Rattle and Sensory Teether Toy",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B000BNCA4K/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B000BNCA4K&linkCode=as2&tag=shopmymom-20&linkId=15762c1fa56aa3a9ec7c2e325787381d",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71drfXxQz3L._SX522_.jpg",
    description: "You can never have enough teething toys!",
    category: ["Toys"]
  },
  {
    name: "Gerber Baby Unisex 6 Pack Socks, White, 0-3 Months",
    price: "9.99 ",
    url:
      "https://www.amazon.com/gp/product/B007C4GHS6/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B007C4GHS6&linkCode=as2&tag=shopmymom-20&linkId=472b1f164064f7a3ef4d1d6f2cdfecf8",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71mWpiwtn%2BL._UX679_.jpg",
    description: "Keeps their feet warm when going out, otherwise seldom used.",
    category: ["Apparel"]
  },
  {
    name:
      "Baby Closet Dividers, First Bouquet, Girl, Set of 6 Size Organizers, Flowers",
    price: "9.90 ",
    url:
      "https://www.amazon.com/gp/product/B07BMJ9GKH/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07BMJ9GKH&linkCode=as2&tag=shopmymom-20&linkId=19a2bf371e3c8ab6099de002e02d48c0",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71XC8X5Tu1L._SX522_.jpg",
    description:
      "When you start organizing their clothes, you‘ll want to segment them by age. You’ll probably want dividers for better clarity. ",
    category: ["Apparel"]
  },
  {
    name:
      "Gerber Unisex-Baby Newborn 4 Pack Organic Onesies Brand, White, Newborn",
    price: "8.94 ",
    url:
      "https://www.amazon.com/gp/product/B007B9K9KO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B007B9K9KO&linkCode=as2&tag=shopmymom-20&linkId=7006759587052f4db2bdffe8dfc7b87a",
    imageUrl:
      "https://images-na.ssl-images-amazon.com/images/I/71WmiitjY3L._UY679_.jpg",
    description:
      "She dresses in onesies all day, all night unless she‘s out and about. There was also a great black friday sale on Gap Kids where everything was 50% off. Stock up on these. ☝️",
    category: ["Apparel"]
  }
];



// WEBPACK FOOTER //
// ./src/data/products0-3months.js